import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
export const insertCPFType = async (payload) => {
  const { data } = await http_payroll.post(Api_EndPoints.InsertCPFType, payload);
  return data;
};

// Update CPF Type
export const updateCPFType = async (payload) => {
  const { data } = await http_payroll.put(Api_EndPoints.UpdateCPFType, payload);
  return data;
};

// Insert Mutation Hook
export const useInsertCPFTypeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: insertCPFType,
    onSuccess: () => {
      queryClient.invalidateQueries([Api_EndPoints.InsertCPFType]);
    },
  });
};

// Update Mutation Hook
export const useUpdateCPFTypeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateCPFType,
    onSuccess: () => {
      queryClient.invalidateQueries([Api_EndPoints.UpdateCPFType]);
    },
  });
};

const getCpfTypes = async ({ companyCode }) => {
  const {data} = await http_payroll.get(
    `${Api_EndPoints.GetCPFTypes}?CompanyCode=${companyCode}`
  );
  return data;
};

export const useCPFTypeQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetCPFTypes],
    queryFn: () => getCpfTypes(companyCode),
    refetchOnWindowFocus: false,
  });
};
